import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Users, Send, BarChart3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const NAV = [
  { to: "/admin/dashboard", label: "Oversikt", icon: LayoutDashboard, end: true, id: "oversikt" },
  { to: "/admin/dashboard/kunder", label: "Kundedatabase", icon: Users, id: "kunder" },
  { to: "/admin/dashboard/kampanjer", label: "Send kampanje", icon: Send, id: "kampanjer" },
  { to: "/admin/dashboard/resultater", label: "Resultat av kampanjer", icon: BarChart3, id: "resultater" },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-[#1A1715] px-4 py-6 sm:px-8">
      <div className="mx-auto max-w-6xl">
        <header className="flex flex-wrap items-center justify-between gap-4">
          <Logo size="text-3xl" />
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-[#A8A29E] sm:inline">{admin?.email}</span>
            <button
              onClick={handleLogout}
              data-testid="admin-logout-btn"
              className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-[#FDFBF7] transition-colors hover:border-[#D4AF37]/50 hover:text-[#D4AF37]"
            >
              <LogOut className="h-4 w-4" /> Logg ut
            </button>
          </div>
        </header>

        <nav className="mt-8 flex gap-1 overflow-x-auto rounded-2xl border border-white/10 bg-[#282421] p-1.5" data-testid="admin-nav">
          {NAV.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`nav-${id}`}
              className={({ isActive }) =>
                `flex flex-shrink-0 items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-[#D4AF37] text-[#1A1715]" : "text-[#A8A29E] hover:bg-white/5 hover:text-[#FDFBF7]"
                }`
              }
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
